import { render } from "./GetParticipantsList.vue?vue&type=template&id=25be4e44"
import script from "./GetParticipantsList.vue?vue&type=script&lang=js"
export * from "./GetParticipantsList.vue?vue&type=script&lang=js"

import "./GetParticipantsList.vue?vue&type=style&index=0&id=25be4e44&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__